export default "__VITE_ASSET__BTfxxYaF__"